import { logger } from 'monitor';

/**
 * Triggers a vibration pattern on devices that support the Vibration API.
 *
 * @param pattern - A vibration pattern as a number (single vibration duration in ms)
 *                  or an array of numbers (alternating vibrate/pause durations in ms)
 * @returns true if vibration was triggered, false if not supported
 *
 * @example
 * // Single vibration for 400ms
 * vibrate(400);
 *
 * @example
 * // Double-pulse pattern: vibrate 300ms, pause 100ms, vibrate 300ms
 * vibrate([300, 100, 300]);
 */
export const vibrate = (pattern: number | number[]): boolean => {
  if ('vibrate' in navigator) {
    logger.info('Vibration pattern:', { pattern });
    return navigator.vibrate(pattern);
  }
  logger.info('Vibration not supported');
  return false;
};

/**
 * Triggers a quick double-pulse vibration pattern.
 * Recommended for error/rejection feedback.
 *
 * Pattern: 300ms vibrate, 100ms pause, 300ms vibrate
 * Total duration: 700ms (within recommended 0.3-0.5s range per pulse)
 */
export const vibrateDoublePulse = (): boolean => {
  logger.info('Vibration double pulse');
  return vibrate([300, 100, 300]);
};
